import { NavSectionType } from "@/types/Context";

export const getNavName = (section:NavSectionType)=>{
    return section.navName||section.heading||section.sectionName||section.sectionForm
}